import { render, staticRenderFns } from "./DraftModeButton.vue?vue&type=template&id=4f6049e6&"
import script from "./DraftModeButton.vue?vue&type=script&lang=ts&"
export * from "./DraftModeButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports